/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum SurveyEngine_Models_WebLayout {
    VERTICAL = 'Vertical',
    HORIZONTAL = 'Horizontal',
    DROPDOWN = 'Dropdown',
    CHECK_BOXES = 'CheckBoxes',
    SELECTION_BOXES = 'SelectionBoxes',
}
